import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { withMfeComponents } from 'yoda-app-shell/lib/mfe/MfeLoader/withMfeComponents';

import irisComponentsForCoupon from 'yoda-site-components/lib/iris/components/forCoupon';
import { hotdealsPostProcessor } from 'yoda-interfaces/lib/IrisPage/IrisPage';
import renderMiniPDP from '../../../helper/MiniPDPHelper';
import couponPageAction from '../../../actions/CouponPageAction';
import { federatedComponents } from 'config/federatedComponents';

export class CouponPage extends PureComponent {
    static defaultProps = {
        location: {},
        actions: {},
        irisFallbackPreferences: {},
        enableMiniPDPFeature: true,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        location: PropTypes.objectOf(PropTypes.object),
        irisFallbackPreferences: PropTypes.objectOf(PropTypes.object),
        enableMiniPDPFeature: PropTypes.bool,
    };

    componentDidMount() {
        const { actions } = this.props;
        actions.getCouponPageLoaded();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps() {
        const catergoryRegex = /\/m\//;

        const { mfeComponents: { NavigationHelper } = {} } = this.props;

        if (
            !catergoryRegex.test(window.location.href) &&
            !window.location.href.includes('coupon')
        ) {
            (NavigationHelper?.default || NavigationHelper)?.navigate(window.location.href);
        }
    }

    render() {
        const {
            location,
            irisFallbackPreferences,
            enableMiniPDPFeature,
            mfeComponents,
        } = this.props;
        const params = location && location.pathname;
        const { IrisPage, Loading: MfeLoading } = mfeComponents || {};

        const renderMiniPDPComponent = enableMiniPDPFeature
            ? renderMiniPDP(MfeLoading)
            : null;

        return (
            <>
                {IrisPage && (
                    <IrisPage
                        params={params}
                        pageType="COUPONS"
                        irisComponents={irisComponentsForCoupon}
                        irisFallbackPreferences={irisFallbackPreferences}
                        aggregateAPI
                        postProcessor={hotdealsPostProcessor}
                        location={location}
                    />
                )}
                {MfeLoading && <MfeLoading />}
                {renderMiniPDPComponent}
            </>
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = ({ context }) => ({
    irisFallbackPreferences: get(context, 'preferences.irisfallbackPreferences', {}),
    enableMiniPDPFeature: get(context, 'featureFlags.enableMiniPDPFeature', true),
});

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(couponPageAction, dispatch),
});

export default compose(
    withMfeComponents(['IrisPage', 'Loading', 'NavigationHelper'], federatedComponents),
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CouponPage);
